module.exports = __webpack_public_path__ + "img/DWCardBackground.e1ea1b00.svg";